<a [routerLink]="eventWebRoute()">
  <div class="relative">
    <img [src]="coverImage()" class="flex-initial aspect-cover w-full object-cover object-center rounded-3xl" [loading]="shouldLoadEagerly() ? 'eager' : 'lazy'" [alt]="name()">

    <div class="z-10 absolute left-5 bottom-5 w-3/5 rounded-2xl bg-white">
      <div class="flex flex-col">
        <h1 class="flex-initial line-clamp-2 text-2xl text-default-light font-semibold tracking-tightest mt-2 mx-4">{{name()}}</h1>

        @if(pricing() != null) {
          <span class="line-clamp-1 text-base text-default-light font-normal tracking-tightest mx-4">{{pricing()}}</span>
        }

        <div class="flex-1"></div>

        <div class="flex flex-row items-end">
          <div class="flex flex-col">
            <app-start-date class="mx-4" [startDate]="event().startDate" [eventDateFormat]="event().eventDateFormat" [timezone]="timezone()"></app-start-date>

            <app-location-info class="mb-3 mx-4" [locationInfo]="event().locationInfo"></app-location-info>
          </div>

          <div class="flex-1"></div>

          <ng-template transloco let-t>
            <app-primary-button class="mb-3 mr-3" [label]="t('event.tickets')" [icon]="'assets/svg/ticket.svg'"></app-primary-button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</a>
